<template>
    <b-modal
        ref="dialog"
        lazy
        title-tag="h2"
        title="Cancel Reservation"
        footer-class="d-flex"
        @show="$emit('loaded')"
    >
        <b-form-group label-cols="3" label="Reason:" label-for="reason">
            <select class="form-control" v-model="reason">
                <option v-for="rsn in reasons" :key="rsn.id" :value="rsn.id">
                    {{ rsn.value }}
                </option>
            </select>
        </b-form-group>
        <b-form-group label-cols="3" label="Notes:" label-for="notes">
            <textarea
                class="form-control"
                placeholder="Notes (optional)"
                v-model="notes"
            />
        </b-form-group>
        <template v-slot:modal-footer="{ close }">
            <loader v-if="isSaving" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isSaving"
            >
                Cancel
            </b-button>

            <b-button v-if="!isSaving" variant="primary" @click="save">
                Save
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import Loader from "@/module/commons/loader";
import BoardingService from "@/services/boarding.js";

export default {
    components: {
        Loader
    },
    data() {
        return {
            isSaving: false,
            boardingId: null,
            reason: null,
            reasons: [],
            notes: "",
            isLoading: false
        };
    },
    methods: {
        async open(boardingId) {
            await this.initReasons();
            this.boardingId = boardingId;
            this.$refs.dialog.show();
        },
        async initReasons() {
            let reasons = await BoardingService.getCancelReasons();
            this.reasons = reasons;
            this.reason = reasons[0] ? reasons[0].id : "";
        },
        async save() {
            try {
                this.isSaving = true;
                await BoardingService.cancelReservation({
                    id: this.boardingId,
                    type: this.reason,
                    notes: this.notes
                });
                this.isSaving = false;
                this._message("Reservation has been canceled.");
                this.$refs.dialog.hide();
                this.$emit("success", this.boardingId);
            } catch (error) {
                this.isSaving = false;
                this._message("Error: Unable to cancel reservation", "danger");
            }
        }
    }
};
</script>
